import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

import { CkeditorConstants } from '../../src/utils';

const { htmlElement: { VIDEO } } = CkeditorConstants;

export default class VideoEditing extends Plugin {
  init() {
    const editor = this.editor;
    const schema = editor.model.schema;

    schema.register('video', {
      allowWhere: '$block',
      allowContentOf: '$root',
      inheritAllFrom: '$block',
      allowAttributes: ['id', 'controls', 'class', 'data-cke-ignore-events', 'preload', 'poster']
    });

    editor.conversion.for('upcast').elementToElement({
      view: VIDEO,
      model: (viewElement, { writer: modelWriter }) => {
      try {
        if (viewElement._children.length > 1 && viewElement._children[0]._textData.trim() === '') {
          viewElement._children[0]._remove();
        }
        return modelWriter.createElement(VIDEO, viewElement.getAttributes());
      } catch (error) {
        console.error('Error in upcast video element:', error);
        throw Error(error);
      }
      }
    });

    editor.conversion.for('downcast').elementToElement({
      model: VIDEO,
      view: VIDEO
    });

    editor.conversion.for('downcast').add(dispatcher => {
      dispatcher.on('attribute', (evt, data, conversionApi) => {          
        if(data.item.name === 'video' && data.attributeKey === 'poster'){
          const viewWriter = conversionApi.writer;
          const viewElement = conversionApi.mapper.toViewElement(data.item);
          const originUrl = location.origin + '/alfresco/s/wk/renditions/imgpreview/content?tenantId=';
          const alf_ticket = localStorage.getItem('ticket-ECM') ;
          if (!data.attributeNewValue?.includes('alf_ticket=') && alf_ticket) {
              data.attributeNewValue = data.attributeNewValue + `&alf_ticket=${alf_ticket}`;
              viewWriter.setAttribute(data.attributeKey, data.attributeNewValue, viewElement);
          }
          if(!data.attributeNewValue?.includes(originUrl)){
            data.attributeNewValue = originUrl + data.attributeNewValue ;
            viewWriter.setAttribute(data.attributeKey, data.attributeNewValue, viewElement);
          }
        }
      });
    });
  }
}